// src/app/u2104Organization/components/form/u2104Role/U2104UseGetOrganizatonRoleHandlers.ts
export interface U3141UseUnLockChildLotChainHandlersParams<T = unknown> {
  doUnLockFn: (id: string, childLotChainId: string) => Promise<unknown>;
  onSuccess?: (row: T) => void;
  onError?: (errors: { error: unknown }) => void;
}

// Return type for useU2104UseGetOrganizatonRoleHandlers hook
export interface U3141UseUnLockChildLotChainHandlersReturn {
  unLockChildLotChain: (id: string, childLotChainId: string) => void;
}

// Handlers for getting organization role
export function useU3141UseUnLockChildLotChainHandlers<T extends { id: string } = { id: string }>({
  doUnLockFn,
  onSuccess,
  onError,
}: U3141UseUnLockChildLotChainHandlersParams<T>): U3141UseUnLockChildLotChainHandlersReturn {
  const unLockChildLotChain = async (id: string, childLotChainId: string) => {
    try {
      const response = (await doUnLockFn(id, childLotChainId)) as { data: { result: T } };
      const row: T = response.data.result;

      if (onSuccess) {
        onSuccess(row);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { unLockChildLotChain };
}
